/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// document.addEventListener('variant:changed', function(event) {
//   value_2 = (event.detail.variant.price);
//   value = (value_2 / 100);
//   fbq('track', 'ViewContent', {
//     content_type: 'product',
//     content_ids: [event.detail.variant.id],
//     value: value,
//     content_name: event.detail.variant.name,
//     content_category: event.detail.variant.type,
//     currency: 'AUD'
//   });

//   gtag('event', 'select_item', {
//     'items': [{
//       'item_id': event.detail.variant.sku,
//       'item_name': event.detail.variant.name,
//       'index': event.detail.variant.position,
//       'item_variant': event.detail.variant.id,
//       'price': value,
//     }]
//   });
  
// });

document.addEventListener('variant:changed', handleTrackingEvent);

function handleTrackingEvent(event) {
  let variant = event.detail.variant;
  let value = variant.price / 100;
  // console.log('Variant changed', variant);
  
  // Delay the Facebook Pixel event
  setTimeout(() => {
    if (typeof fbq === 'function') {
      try {
        
        fbq('trackCustom', 'VariantView', {
          content_type: 'product',
          content_ids: [variant.id],
          value: value,
          content_name: variant.name,
          content_category: variant.type,
          currency: 'AUD'
        });
        // console.log('Facebook Pixel VariantView event triggered with delay', {
        //   content_type: 'product',
        //   content_ids: [variant.id],
        //   value: value,
        //   content_name: variant.name,
        //   content_category: variant.type,
        //   currency: 'AUD'
        // });
      } catch (error) {
        console.error('Error triggering Facebook Pixel event:', error);
      }
    } else {
      console.warn('Facebook Pixel (fbq) is not defined');
    }
  }, 1000); // 500ms delay, adjust if needed

  // Check if gtag is defined
  if (typeof gtag === 'function') {
    try {
      gtag('event', 'select_item', {
        'items': [{
          'item_id': variant.sku,
          'item_name': variant.name,
          'index': variant.position,
          'item_variant': variant.id,
          'price': value,
        }]
      });
      console.log('Google Analytics select_item event triggered');
    } catch (error) {
      console.error('Error triggering Google Analytics event:', error);
    }
  } else {
    console.warn('Google Analytics (gtag) is not defined');
  }
}

// window.addEventListener("klaviyoForms", function(e) { 
//     if (e.detail.type == 'submit') {
//       gtag('event', 'form_submit', {'form': 'Klaviyo form', 'form_id': e.detail.formId});
//     }
//     if (e.detail.type == 'stepSubmit') {
//       gtag('event', 'form_step_submit', {'form': 'Klaviyo form', 'step_name': e.detail.metaData.$step_name});
//     }
// });

// window.addEventListener('klaviyoForms', function(e) {

//   if (!e.detail || !e.detail.event) return;

//   if (e.detail.event === 'stepSubmit') {
//     gtag('event', 'klaviyo_step_submit', {
//       event_category: 'engagement',
//       event_label: e.detail.formId || 'unknown_form_step'
//     });
//   }

//   if (e.detail.event === 'submit') {
//     gtag('event', 'klaviyo_signup', {
//       event_category: 'engagement',
//       event_label: e.detail.formId || 'unknown_form_submit'
//     });
//   }
// });



window.addEventListener('klaviyoForms', function(e) {
  if (!e.detail || !e.detail.event) return;
  
  if (e.detail.event === 'stepSubmit') {
    if (window.Shopify && window.Shopify.analytics) {
      Shopify.analytics.publish('klaviyo_step_submit', {
        event_category: 'engagement',
        event_label: e.detail.formId || 'unknown_form_step'
      });
    }
  }
  
  if (e.detail.event === 'submit') {
    if (window.Shopify && window.Shopify.analytics) {
      Shopify.analytics.publish('klaviyo_signup', {
        event_category: 'engagement',
        event_label: e.detail.formId || 'unknown_form_submit'
      });
    }
  }
});

window.addEventListener('load', function() {
  
  var _learnq = window._learnq || [];
  var isProcessing = false;
  
  function sendAddToCartEvent() {
    if (isProcessing) {
      return;
    }
    
    isProcessing = true;

    
    // Small delay to ensure cart is updated
    setTimeout(() => {
      fetch(`${window.location.origin}/cart.js`)
        .then(res => res.json())
        .then(data => {
          
          if (data.items.length > 0) {
            var cart = {
              total_price: data.total_price / 100,
              $value: data.total_price / 100,
              total_discount: data.total_discount / 100,
              original_total_price: data.original_total_price / 100,
              items: data.items,
              item_count: data.item_count
            };
            
            _learnq.push(['track', 'Added to Cart', cart]);
          } else {
            console.log('❌ No items in cart, not sending event');
          }
          
          // Reset processing flag
          setTimeout(() => {
            isProcessing = false;
          }, 1000);
        })
        .catch(err => {
          console.error('❌ Error:', err);
          isProcessing = false;
        });
    }, 300);
  }

  // ONLY track when cart/add.js is called (actual add to cart)
  (function (ns, fetch) {
    ns.fetch = function() {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        if (res.url && res.url.includes('/cart/add.js') && res.ok) {
          sendAddToCartEvent();
        }
      });
      return response;
    }
  }(window, window.fetch));

});


// Gift box

// document.addEventListener('DOMContentLoaded', function() {
//     const giftBoxVariantId = 20039357857890; // Your provided gift box variant ID
    
//     function calculateGiftBoxQuantity(cart) {
//         return cart.items.reduce((total, item) => {
//             // Exclude the gift box from the calculation
//             if (item.variant_id !== giftBoxVariantId) {
//                 if (item.product_type === '3 Pack') {
//                     return total + 3;
//                 } else if (item.product_type === '6 Pack') {
//                     return total + 6;
//                 } else {
//                     return total + item.quantity;
//                 }
//             }
//             return total;
//         }, 0);
//     }

//     function addGiftBoxToCart(button) {
//         setButtonLoading(button, true);
//         fetch('/cart.js')
//             .then(response => response.json())
//             .then(cart => {
//                 const quantity = Math.ceil(calculateGiftBoxQuantity(cart) / 3);
//                 console.log('Calculated gift box quantity:', quantity);
//                 return fetch('/cart/add.js', {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify({
//                         id: giftBoxVariantId,
//                         quantity: quantity
//                     })
//                 });
//             })
//             .then(response => response.json())
//             .then(data => {
//                 console.log('Gift box added to cart:', data);
//                 // Refresh the cart
//                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                     bubbles: true
//                 }));
//             })
//             .catch(error => {
//                 console.error('Error adding gift box to cart:', error);
//             })
//             .finally(() => {
//                 setButtonLoading(button, false);
//             });
//     }

//     // Add click event listener
//     document.addEventListener('click', function(event) {
//         if (event.target && event.target.id === 'add-gift-box') {
//             event.preventDefault();
//             console.log('Add Gift Box button clicked');
//             addGiftBoxToCart(event.target);
//         }
//     });

//     // Listen for cart updates
//     document.addEventListener('cart:updated', function(event) {
//         console.log('Cart updated event received');
//         fetch('/cart.js')
//             .then(response => response.json())
//             .then(cart => {
//                 const quantity = Math.ceil(calculateGiftBoxQuantity(cart) / 3);
//                 const giftBoxItem = cart.items.find(item => item.variant_id === giftBoxVariantId);
                
//                 if (giftBoxItem && giftBoxItem.quantity !== quantity) {
//                     console.log('Updating gift box quantity');
//                     return fetch('/cart/change.js', {
//                         method: 'POST',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify({
//                             id: giftBoxItem.variant_id,
//                             quantity: quantity
//                         })
//                     });
//                 }
//             })
//             .then(response => response ? response.json() : null)
//             .then(data => {
//                 if (data) {
//                     console.log('Gift box quantity updated:', data);
//                     // Refresh the cart
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                         bubbles: true
//                     }));
//                 }
//             })
//             .catch(error => {
//                 console.error('Error updating gift box quantity:', error);
//             });
//     });

//     // Loading spinner functionality
//     function setButtonLoading(button, isLoading) {
//         if (isLoading) {
//             button.setAttribute('aria-busy', 'true');
//             if (!button.originalContent) {
//                 button.originalContent = button.innerHTML;
//                 button.innerHTML = `
//                     <span class="loader-button__text">${button.originalContent}</span>
//                     <span class="loader-button__loader" hidden>
//                         <div class="spinner">
//                             <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
//                                 <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
//                             </svg>
//                         </div>
//                     </span>
//                 `;
//             }
//             startButtonTransition(button);
//         } else {
//             button.setAttribute('aria-busy', 'false');
//             endButtonTransition(button);
//         }
//     }

//     function startButtonTransition(button) {
//         const textElement = button.querySelector('.loader-button__text');
//         const spinnerElement = button.querySelector('.loader-button__loader');

//         textElement.animate({
//             opacity: [1, 0],
//             transform: ["translateY(0)", "translateY(-10px)"]
//         }, {
//             duration: 75,
//             easing: "ease",
//             fill: "forwards"
//         });

//         spinnerElement.hidden = false;
//         spinnerElement.animate({
//             opacity: [0, 1],
//             transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"]
//         }, {
//             duration: 75,
//             delay: 75,
//             easing: "ease",
//             fill: "forwards"
//         });
//     }

//     function endButtonTransition(button) {
//         const textElement = button.querySelector('.loader-button__text');
//         const spinnerElement = button.querySelector('.loader-button__loader');

//         spinnerElement.animate({
//             opacity: [1, 0],
//             transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"]
//         }, {
//             duration: 75,
//             delay: 100,
//             easing: "ease",
//             fill: "forwards"
//         }).onfinish = () => spinnerElement.hidden = true;

//         textElement.animate({
//             opacity: [0, 1],
//             transform: ["translateY(10px)", "translateY(0)"]
//         }, {
//             duration: 75,
//             delay: 175,
//             easing: "ease",
//             fill: "forwards"
//         });
//     }
// });